/**
 * FR8BOT API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const SortDirection = {
    Asc: 'ASC',
    Desc: 'DESC'
} as const;
export type SortDirection = typeof SortDirection[keyof typeof SortDirection];

